export enum CustomRoute {
  NULLABLE = 'null',
}
